<template>
  <div>
    <el-drawer
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      :size="1200"
      top="5vh"
      :title="title"
      :close-on-press-escape="false"
      :before-close="() => cancel()"
    >
      <div class="drawer-main">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          :disabled="disabled"
          size="mini"
        >
          <el-descriptions :column="12" size="small " border>
            <el-descriptions-item :span="4">
              <template slot="label">
                {{ $l('from_label_budget_year') || '预算年度' }}
              </template>
              {{ detailForm.budgetYear }}
            </el-descriptions-item>
            <el-descriptions-item :span="4">
              <template slot="label">
                {{ $l('from_label_department_name') || '部门名称' }}
              </template>
               {{ detailForm.depName }}
            </el-descriptions-item>
            <el-descriptions-item :span="4">
              <template slot="label">
                {{ $l('from_label_team_name') || '团队名称' }}
              </template>
               {{ detailForm.teamName }}
            </el-descriptions-item>

            <el-descriptions-item :span="6">
              <template slot="label">
                {{ $l('from_label_cust_name') || '客户' }}
              </template>
              <el-form-item prop="custCode">
                <el-select
                  v-model="formData.custCode"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  size="mini"
                  filterable
                  clearable
                  style="width: 100%"
                  @change="selectCustomerCategory"
                >
                  <el-option
                    v-for="item in customerOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                {{ $l('form_label_quarter_budget') || '预算金额' }}
              </template>
              {{ budgetTotalFormat }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                {{ $l('from_label_estimated_quantity') || '预计数量' }}
              </template>
              {{ estimatedQtyTotalFormat }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                {{ $l('from_label_first_quarter_budget') || '一季度预算' }}
              </template>
              {{ budgetQ1TotalFormat }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                {{ $l('from_label_second_quarter_budget') || '二季度预算' }}
              </template>
              {{ budgetQ2TotalFormat }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                {{ $l('from_label_third_quarter_budget') || '三季度预算' }}
              </template>
              {{ budgetQ3TotalFormat }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                {{ $l('from_label_fourth_quarter_budget') || '四季度预算' }}
              </template>
              {{ budgetQ4TotalFormat }}
            </el-descriptions-item>
          </el-descriptions>
          <el-row class="mt-1">
            <BudgetTable
              :tableData="budgetTableData"
              :disabled="disabled"
              ref="budgetTable"
              @updateTableData="updateTableData"
            >
              <template v-slot:header>
                <div class="d-flex mt-2">
                  <div class="side-frame-success">
                    <span style="font-size: 14px; color: #606266">
                      {{ $l('form_label_add_budgets') || '添加部门季度预算' }}
                    </span>
                    <el-divider direction="vertical"></el-divider>
                    <el-button
                      size="mini"
                      type="primary"
                      plain
                      :disabled="disabled"
                      @click="addBudget"
                    >
                      {{ $l('INDEX.btn_add') || '新增' }}
                    </el-button>
                  </div>
                </div>
              </template>
            </BudgetTable>
          </el-row>
        </el-form>
        <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
          <span slot="footer">
            <el-button size="small" @click="cancel()">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              v-if="!disabled"
              @click="save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </span>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="mini">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="mini">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="mini">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import BudgetTable from './budget-table.vue'
import Math from '@/libs/util.math.js'
import { format, add } from '@/libs/util.number.js'
import { request } from '@/api/service'
const initFrom = {
  custCode: '',
  budgetQ1: 0,
  budgetQ2: 0,
  budgetQ3: 0,
  budgetQ4: 0,
  estimatedQty: 0,
  custName: '',
}
export default {
  mixins: [EditLoading],
  components: { BudgetTable },
  props: {
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    reportBudgetCode: { type: String, default: '' },
    quarterVisible: { type: Boolean, default: false },
    quarterData: { type: Object, default: () => {} },
  },
  watch: {
    quarterData: {
      handler() {
        this.loadSelectData()
        if (this.quarterData) {
          this.tableData = this.deepClone(
            this.quarterData.budgetMonthList
              ? this.quarterData.budgetMonthList
              : []
          )
          this.formData = {
            custCode: this.quarterData.custCode,
            custName: this.quarterData.custName,
            masterCategoryName: this.quarterData.masterCategoryName,
            uuid: this.quarterData.uuid,
            reportBudgetCustomerCode:
              this.quarterData.reportBudgetCustomerCode || '',
            budgetQ1: this.quarterData.budgetQ1 ? this.quarterData.budgetQ1 : 0,
            budgetQ2: this.quarterData.budgetQ2 ? this.quarterData.budgetQ2 : 0,
            budgetQ3: this.quarterData.budgetQ3 ? this.quarterData.budgetQ3 : 0,
            budgetQ4: this.quarterData.budgetQ4 ? this.quarterData.budgetQ4 : 0,
            subBudget: this.quarterData.subBudget
              ? this.quarterData.subBudget
              : 0,
            estimatedQty: this.quarterData.estimatedQty
              ? this.quarterData.estimatedQty
              : 0,
            masterCategoryCode: this.quarterData.masterCategoryCode,
          }
          this.getData()
        }
      },
      immediate: true,
    },
  },
  computed: {
    estimatedQtyTotal() {
      return this.computedBudgetTableData
        .map((item) => item.estimatedQty)
        .reduce((a, b) => add(a, b), 0)
    },
    estimatedQtyTotalFormat() {
      return format(this.estimatedQtyTotal)
    },
    budgetQ1Total() {
      return this.computedBudgetTableData
        .map((item) => item.budgetQ1)
        .reduce((a, b) => add(a, b), 0)
    },
    budgetQ1TotalFormat() {
      return format(this.budgetQ1Total)
    },
    budgetQ2Total() {
      return this.computedBudgetTableData
        .map((item) => item.budgetQ2)
        .reduce((a, b) => add(a, b), 0)
    },
    budgetQ2TotalFormat() {
      return format(this.budgetQ2Total)
    },
    budgetQ3Total() {
      return this.computedBudgetTableData
        .map((item) => item.budgetQ3)
        .reduce((a, b) => add(a, b), 0)
    },
    budgetQ3TotalFormat() {
      return format(this.budgetQ3Total)
    },
    budgetQ4Total() {
      return this.computedBudgetTableData
        .map((item) => item.budgetQ4)
        .reduce((a, b) => add(a, b), 0)
    },
    budgetQ4TotalFormat() {
      return format(this.budgetQ4Total)
    },
    budgetTotalFormat() {
       return format(add(this.budgetQ4Total, add(this.budgetQ3Total,add(this.budgetQ2Total,this.budgetQ1Total))))
    },
  },
  data() {
    return {
      backDialogVisible: false,
      customerOptions: [], //客户
      budgetTableData: [],
      computedBudgetTableData: [],
      formData: { ...initFrom },
      detailForm: {},
      tableData: [],
      rules: {
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择客户',
            trigger: 'change',
          },
        ],
      },
    }
  },

  methods: {
    getData() {
      if (this.reportBudgetCode) {
        this.$api
          .orderBudgetCustomerDetailApi({
            reportBudgetCustomerCode: this.formData.reportBudgetCustomerCode,
            reportBudgetCode: this.reportBudgetCode,
          })
          .then((res) => {
            this.detailForm = res?.body || {}
            this.formData.custCode = this.detailForm.custCode
            this.budgetTableData = this.detailForm.quarterList || []
            this.computedBudgetTableData = this.budgetTableData
          })
      }
    },
    updateTableData(items) {
      this.computedBudgetTableData = [...items]
    },
    deepClone(data) {
      var newData = Array.isArray(data) ? [] : {}
      for (var key in data) {
        if (typeof data[key] != 'object') {
          newData[key] = data[key]
        } else {
          newData[key] = this.deepClone(data[key])
        }
      }
      return newData
    },

    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      const budgetTableList = this.$refs.budgetTable.getTableData()
      if (!budgetTableList || !budgetTableList.length) {
        this.$message.warning(
          this.$l('tips_check_budget') || '请检查部门预算是否填写'
        )
        return
      }
      console.log(budgetTableList)
      this.formData.budgetQ1 = this.budgetQ1Total
      this.formData.budgetQ2 = this.budgetQ2Total
      this.formData.budgetQ3 = this.budgetQ3Total
      this.formData.budgetQ4 = this.budgetQ4Total
      this.formData.reportBudgetCode = this.reportBudgetCode
      this.formData.estimatedQty = this.estimatedQtyTotal
      this.loadingOpen()

      this.$api
        .orderBudgetCustomerSaveApi({
          ...this.formData,
          childs: budgetTableList,
        })
        .then((res) => {
          const { status } = res || {}
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.$emit('reload')
          this.close()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    addBudget() {
      this.$refs.budgetTable.push({
        masterCategoryCode: '',
        estimatedQty: 0,
        budgetQ1: 0,
        budgetQ2: 0,
        budgetQ3: 0,
        budgetQ4: 0,
      })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    add(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
    },
    loadSelectData() {
      //客户
      request({
        url: '/digitalCenter/common/dict/customer',
        method: 'post',
        data: {},
      }).then((res) => {
        this.customerOptions = res.body.data
        this.customerOptions.push({ label: 'Others', value: 'Others' })
      })
    },
    selectCustomerCategory(value) {
      //下拉框选中事件
      let obj = this.customerOptions.find((item) => {
        return item.value === value
      })
      this.formData.custName = obj.label
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 32px;
}
::v-deep .el-form .el-form-item {
  margin-bottom: 6px !important;
}
::v-deep .el-input__inner{
  height: 28px;
  line-height: 28px;
}
</style>
